import { render, staticRenderFns } from "./BankMatchInvoice.vue?vue&type=template&id=270bd374"
import script from "./BankMatchInvoice.vue?vue&type=script&lang=js"
export * from "./BankMatchInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports